import * as React from 'react';
import {Link, useParams} from 'react-router-dom';
import {useCallback, useEffect, useState} from "react";
import {deletePayment, getPayment} from "../../../api";
import {useHistory} from "react-router";


const ViewPayment: React.FunctionComponent = () => {

    const {clientId, paymentId} = useParams();
    const [amount, setAmount] = useState("");
    const [createdAt, setCreatedAt] = useState("");
    const [method, setMethod] = useState("");

    const [cardNumber, setCardNumber] = useState("");
    const [cvv, setCvv] = useState("");
    const [zip, setZip] = useState("");
    const [expireMonth, setExpireMonth] = useState("");
    const [expireYear, setExpireYear] = useState("");
    const [doSearchRedirect, setDoSearchRedirect] = useState(false);

    const history = useHistory();

    const load = useCallback(() => {
        getPayment(clientId, paymentId)
            .then((p) => {
                setAmount("" + p.amount);
                setCreatedAt(p.paymentDate);
                setMethod(p.method);
                if (p.creditCard !== undefined) {
                    setCardNumber(p.creditCard?.creditCardNumber)
                    setCvv(p.creditCard.cvv);
                    setZip(p.creditCard.zipCode);
                    setExpireYear(p.creditCard.expirationYear);
                    setExpireMonth(p.creditCard.expirationMonth);
                }
            });
    }, [clientId, paymentId]);

    useEffect(() => {
        if (doSearchRedirect) {
            history.push({
                pathname: "/m/clients/view/" + clientId
            });
        }
    }, [doSearchRedirect, history, clientId]);

    useEffect(() => {
        load();
    }, [load]);

    const doDelete = () => {
        deletePayment(clientId, paymentId)
            .then((r) => {
                if (r.ok) {
                    setDoSearchRedirect(true);
                }
            })
    }


    return (<>
        <form>
            <div className={"row"}>
                <div className={"col-lg-12 mb-3 "}>
                    <h2>View Payment</h2>
                </div>

                <div className={"col-lg-12 mb-3 "}>
                    <h6>Item Details</h6>
                </div>
                <div className={"col-lg-12 mb-3 "}>

                    <div className="form-row align-items-center">

                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Amount</label>
                            <input type="text" className="form-control" id="inlineFormInputName" disabled={true}
                                   value={amount} onChange={(e) => setAmount(e.target.value)}/>
                        </div>
                        <div className="col-sm-3 my-1">
                            <label htmlFor="inputEmail4">Transaction Date</label>
                            <input type="date" className="form-control" id="inlineFormInputName"
                                   disabled={true}
                                   value={createdAt} onChange={(e) => setCreatedAt(e.target.value)}/>
                        </div>
                    </div>
                </div>
                <div hidden={method !== "CREDIT_CARD"}>
                    <div className={"col-lg-12 mb-3 "}>
                        <h6>Card Information</h6>
                    </div>
                    <div className={"col-lg-12 mb-3 "}>
                        <div className="form-row align-items-center">

                            <div className="col-sm-5 my-1">
                                <label htmlFor="inputEmail4">Card Number</label>
                                <input type="text" className="form-control" id="inlineFormInputName" disabled={true}
                                       value={cardNumber} onChange={(e) => setCardNumber(e.target.value)}/>
                            </div>
                            <div className="col-sm-3 my-1">
                                <label htmlFor="inputEmail4">CVV</label>
                                <input type="number" className="form-control" id="inlineFormInputName" disabled={true}
                                       value={cvv} onChange={(e) => setCvv(e.target.value)}/>
                            </div>
                            <div className="col-sm-3 my-1">
                                <label htmlFor="inputEmail4">Zip</label>
                                <input type="text" className="form-control" id="inlineFormInputName" disabled={true}
                                       value={zip} onChange={(e) => setZip(e.target.value)}/>
                            </div>
                        </div>
                        <div className="form-row align-items-center">

                            <div className="col-sm-2 my-1">
                                <label htmlFor="inputEmail4">Expire Month</label>
                                <input type="number" className="form-control" id="inlineFormInputName" disabled={true}
                                       value={expireMonth} onChange={(e) => setExpireMonth(e.target.value)}/>
                            </div>
                            <div className="col-sm-2 my-1">
                                <label htmlFor="inputEmail4">Expire Year</label>
                                <input type="number" className="form-control" id="inlineFormInputName" disabled={true}
                                       value={expireYear} onChange={(e) => setExpireYear(e.target.value)}/>
                            </div>

                        </div>
                    </div>
                </div>
                <div className={"col-lg-12 mb-3 "}>
                    <Link to={"/m/clients/view/" + clientId}>
                        <button type={"submit"} className={"btn btn-danger mr-3"}>Back</button>
                    </Link>
                    <button type={"submit"} className={"btn btn-primary"}
                            onClick={(e) => {
                                e.preventDefault();
                                doDelete();
                            }}>Delete
                    </button>
                </div>

            </div>
        </form>
    </>);
};

export default ViewPayment;